import $ from 'jquery';

// const container = document.querySelector('#share_notifications');
const container = document.querySelector('#video_notifications');

// const template = {
//     eventName: 'videoOneOnOne',
//     senderId: userProperties.userId,
//     data: {
//       withCamera,
//       withSound,
//       scopeId,
//       scopeDisplayName,
//       peerInfo
//     },
//     senderInfo: {
//       id: userProperties.userId,
//       name: userProperties.userName,
//       avatar_url: userProperties.userAvatarUrl
//     }
//   }

class ScreenShareRequestNotification {
    constructor({data, senderInfo, requestToShareScreenText}){

        this.data = data;
        this.senderInfo = senderInfo;
        this.requestToShareScreenText = requestToShareScreenText;

        $(`.video_notification_from_${this.senderInfo.id}`).remove();
        $(container).append( this.createNotification() );
        $('#notifications_holder').addClass('expanded');
    }

    createNotification = () =>{
        return `
            <div class='scrren_request call_notification video_notification_from_${this.senderInfo.id}'>
                <input type='hidden' class='call_unique_class' value='video_notification_from_${this.senderInfo.id}' />
                <input type='hidden' class='call_scope_name' value='${this.data.scopeDisplayName}' />
                <input type='hidden' class='call_objID' value='${this.data.objID}' />
                <input type='hidden' class='call_scope_id' value='${this.data.scopeId}' />
                <section class='senderInfo'>
                    <div class='call_sender_avatar avatar_${this.senderInfo.id}'>
                        <img src='${this.senderInfo.avatar_url}' alt='Sender avatar image' class='call_sender_img avatar_${this.senderInfo.id}' onError='this.src = "textures/defaultAvatar.png"' />
                    </div>
                    <p class='call_sender_name username_${this.senderInfo.id}'>${this.senderInfo.name}</p>
                    <span class='call_sender_msg' data-lang="requests-to-share-screen-text">${this.requestToShareScreenText}</span>
                </section>
                <section class='call_cta'>
                    <div class='btn approve_screen_share'>
                        <span class="material-icons">check</span>
                    </div>
                    <div class='btn deny_screen_share'>
                        <span class="material-icons">close</span>
                    </div>
                </section>
            </div>
        `;
    }
}

export default ScreenShareRequestNotification;